<div *ngIf="replyItem && replyItem.isDone" class="row">
  <div *ngIf="order.id" class="col-lg-12">
    <p>{{'doctrine.solution.action_reorder.dealer.message' | translate}}</p>
    <div class="d-inline-block">
      <div class="pull-left me-4">{{'doctrine.solution.action_reorder.dealer.check_order' | translate}}</div>
      <div class="pull-left">
        <a (click)="goToOrder()"><u>{{order.orderNo}}</u></a>
      </div>
    </div>
    <p class="pt-4">
      <button type="button" class="btn btn-primary btn-file" (click)="openOrderPdfFile()">
        <i class="fa fa-file-pdf-o"></i>
      </button>
    </p>
  </div>
</div>
